import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

const OrganisationData = ({ organization } = {}) => {
  const { name, url, telephone, areaServed, logo, description, sameAs } = organization;
  let contactPoint;
  if (telephone && areaServed) {
    contactPoint = [{
      '@type': 'ContactPoint',
      contactType: 'customer service',
      telephone,
      areaServed,
    }];
  }
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name,
    description,
    url,
    logo,
    sameAs,
    contactPoint,
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

OrganisationData.propTypes = {
  organization: PropTypes.object,
};

export default OrganisationData;
